import { Button, Headline, Stack, Tag } from '@servicetitan/design-system';
import styles from '../../CustomerDetails.module.css';
import Location from '../../../Location';
import CustomerCardWrapper from '../CustomerCardWrapper/CustomerCardWrapper';
import { Location as CustomerLocation } from '@api/generated/graphql';

interface CustomerLocationsProps {
  locations: CustomerLocation[];
  onViewAllClicked: () => void;
  onLinkOutClicked?: (id: string) => void;
}

const CustomerLocations = ({
  locations,
  onViewAllClicked,
  onLinkOutClicked,
}: CustomerLocationsProps) => {
  const shouldShowViewAllButton = locations.length > 3;
  const firstThreeLocations = locations.slice(0, 3);

  return (
    <CustomerCardWrapper>
      <Stack className={styles.customerHeader} alignItems='center' spacing={1}>
        <Headline className='m-0' size='small'>
          Location
        </Headline>
        <div className='m-t-half m-b-half'>
          <Tag badge compact>
            {locations.length}
          </Tag>
        </div>
      </Stack>
      <div>
        {firstThreeLocations.map((location) => (
          <Location
            key={location.id}
            address={location.address}
            onLinkOutClicked={
              onLinkOutClicked ? () => onLinkOutClicked(location.id) : undefined
            }
          />
        ))}
        {shouldShowViewAllButton && (
          <Button
            size='xsmall'
            fill='subtle'
            color='primary'
            onClick={onViewAllClicked}
            aria-label='View All'
          >
            View All
          </Button>
        )}
      </div>
    </CustomerCardWrapper>
  );
};

export default CustomerLocations;
